<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" :style="blockStyle">
        <cms-block-renderer v-for="child in block.children" :key="child.id" @block-selected="selectBlock" :block="child" :block-selection="blockSelection"
                            :parent="block" :editable="editable"/>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-inline #hot-reload-debug
export default {
    name: `cms-block-inline`,
    components: {
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    computed: {
        blockStyle() {
            return {
                "--gap-spacing": this.block.spacing
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-inline {
    --gap-spacing: 0;

    ::v-deep .cms-container {
        flex-direction: row;
        column-gap: var(--gap-spacing);

        .cms-block {
            .cms-container {
                padding-top: 0 !important;
                padding-bottom: 0 !important;
            }
        }
    }
}
</style>
